const _version = "2.10.1"
function version() {
    return _version;
}
export default version
